import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
const StartSelling = () => {
    return (
        <section className='StartSelling'>
            <Container>
                <Row>
                    <Col lg={12}>
                        <div className="StartSellingBox">
                            <h2>Start selling online through the funnel.</h2>
                            <p>Build your business with Funnel Liner to sell online products and everywhere in between.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default StartSelling;